import { render, staticRenderFns } from "./informationBar.vue?vue&type=template&id=78c778f8&scoped=true"
import script from "./informationBar.vue?vue&type=script&lang=js"
export * from "./informationBar.vue?vue&type=script&lang=js"
import style0 from "./informationBar.vue?vue&type=style&index=0&id=78c778f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c778f8",
  null
  
)

export default component.exports